import { useToasts } from 'react-toast-notifications'
import { useCallback } from 'react'
import { ApolloError } from '@apollo/client'
import { useRetryLabOrderMutation } from '../feedQueries.generated'
import { useFeedContext } from '../feedContext'

export default function useRetryLabOrder() {
  const feedContext = useFeedContext()
  const [retryLabOrderMutation, retryLabOrderStatus] = useRetryLabOrderMutation()
  const { addToast } = useToasts()

  const retryLabOrder = useCallback(
    async (orderID: string) => {
      try {
        await retryLabOrderMutation({ variables: { orderID } })
        addToast('Lab ordered successfully', { appearance: 'success' })

        feedContext.fetchMoreNewer().catch(() => {
          // Nothing to do
        })
      } catch (err) {
        if (err instanceof ApolloError && err.graphQLErrors[0]?.extensions.clientError) {
          addToast(err.message)
        } else {
          addToast('Failed to retry lab order')
        }
      }
    },
    [addToast, retryLabOrderMutation, feedContext]
  )

  return [retryLabOrder, retryLabOrderStatus] as const
}
